import CONSTANTS from '../constants'
import { getRequest, putRequest, postRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'

// Calls the API to get Facility Initials
export const getCardDataList = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_CARD_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_CARD_LIST_REQUEST })
    let endpoint = `${APICONFIG.getCardDataUrl}`    
    return getRequest(endpoint).then((res) => {
        let resObject = {  ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_CARD_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.GET_CARD_LIST_SUCCESS, data: res.data })
        return res
    }).catch((error) => {
        let errObject = { ...error }
		dispatch(addEventLog(errObject, CONSTANTS.GET_CARD_LIST_FAILURE))
        dispatch({ type: CONSTANTS.GET_CARD_LIST_FAILURE })
        return error
    })
}


export const createCardData = (payload) => dispatch => {
    dispatch(addEventLog(payload, CONSTANTS.CREATE_CARD_REQUEST))
    dispatch({ type: CONSTANTS.CREATE_CARD_REQUEST })
    return postRequest(APICONFIG.createCardUrl, payload).then((res) => {
        let resObject = { ...payload, ...res}
		dispatch(addEventLog(resObject, CONSTANTS.CREATE_CARD_SUCCESS))
        dispatch({ type: CONSTANTS.CREATE_CARD_SUCCESS, data: res.data })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err}
		dispatch(addEventLog(errObject, CONSTANTS.CREATE_CARD_FAILURE))
        dispatch({ type: CONSTANTS.CREATE_CARD_FAILURE })
        return err
    })
}

export const updateCardData = (payload, cardId) => (dispatch) => {
    const logPayload = {
        payload : payload,
        cardId: cardId
    }
    dispatch(addEventLog(logPayload, CONSTANTS.UPDATE_CARD_REQUEST))
    dispatch({ type: CONSTANTS.UPDATE_CARD_REQUEST })
    return putRequest(`${APICONFIG.updateCardDataUrl}/${cardId}`, payload).then((res) => {
        let resObject = {...logPayload, ...res} 
        dispatch(addEventLog(resObject, CONSTANTS.UPDATE_CARD_SUCCESS))
        dispatch({ type: CONSTANTS.UPDATE_CARD_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = {...logPayload, ...err} 
        dispatch(addEventLog(errObject, CONSTANTS.UPDATE_CARD_FAILURE))
        dispatch({ type: CONSTANTS.UPDATE_CARD_FAILURE })
    })
}


export const removeCardData = (cardData) => dispatch => {
    dispatch(addEventLog(cardData, CONSTANTS.CARD_DELETE_REQUEST))
    dispatch({ type: CONSTANTS.CARD_DELETE_REQUEST })
    return postRequest(`${APICONFIG.removeCardUrl}`, cardData).then((res) => {
        let resObject = {...cardData, ...res} 
        dispatch(addEventLog(resObject, CONSTANTS.CARD_DELETE_SUCCESS))
        dispatch({ type: CONSTANTS.CARD_DELETE_SUCCESS })
        return res
    }).catch((err) => {
        let errObject = {...cardData, ...err} 
        dispatch(addEventLog(errObject, CONSTANTS.CARD_DELETE_FAILED))
        dispatch({ type: CONSTANTS.CARD_DELETE_FAILED })
        return err
    })
}



export const makeDefaultCardData = (cardData) => dispatch => {
    dispatch(addEventLog(cardData, CONSTANTS.CARD_UPDATE_REQUEST))
    dispatch({ type: CONSTANTS.CARD_UPDATE_REQUEST })
    return postRequest(`${APICONFIG.updateDefaultCard}`, cardData).then((res) => {
        let resObject = {...cardData, ...res} 
        dispatch(addEventLog(resObject, CONSTANTS.CARD_UPDATE_SUCCESS))
        dispatch({ type: CONSTANTS.CARD_UPDATE_SUCCESS })
        return res
    }).catch((err) => {
        let errObject = {...cardData, ...err}
        dispatch(addEventLog(errObject, CONSTANTS.CARD_UPDATE_FAILED))
        dispatch({ type: CONSTANTS.CARD_UPDATE_FAILED })
        return err
    })
}